var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgClose = function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.643 4.355c.476.474.476 1.243.001 1.718l-5.643 5.644a.4.4 0 0 0 0 .566l5.643 5.644c.436.435.471 1.118.108 1.593l-.109.125a1.217 1.217 0 0 1-1.72-.001L12.282 14a.4.4 0 0 0-.566 0l-5.64 5.643a1.217 1.217 0 0 1-1.72 0 1.214 1.214 0 0 1 0-1.717l5.643-5.644a.4.4 0 0 0 0-.566L4.356 6.073a1.214 1.214 0 0 1-.108-1.594l.109-.124a1.217 1.217 0 0 1 1.72.001l5.64 5.641a.4.4 0 0 0 .565 0l5.641-5.64a1.217 1.217 0 0 1 1.72-.002Z",
    fill: "#252A31",
    stroke: "#252A31",
    strokeWidth: 0.5
  })));
};
export default SvgClose;